import { createApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App'
import router from './router'
import { useScreenStore } from "@/store";
import { getScrollbarWidth } from '@/utils'

import '@/styles/index.scss'

const pinia = createPinia()

createApp(App)
  .use(router)
  .use(pinia)
  .mount('#app')

// 获取屏幕类型
const store = useScreenStore()
let scrollbarWidth = getScrollbarWidth()

function getScreen() {
  let clientWidth = document.body.clientWidth
  
  let width = scrollbarWidth ? clientWidth + scrollbarWidth : clientWidth;
  let type
  if (width > 1200) {
    //大屏幕
    type = 2
  } else if (width > 750) {
    //中屏幕
    type = 1
  } else {
    //小屏幕
    type = 0
  }
  store.updateScreen(type)
}

getScreen()
window.addEventListener("resize", getScreen)
